class MainSearch extends SearchForm {
  constructor() {
    super();
    this.allSearchInputs = document.querySelectorAll('input[type="search"]');
    this.setupEventListeners();

    this.input = document.getElementById('Search-In-Template');
    this.resetBtn = this.input?.closest('form')?.querySelector('button[type="reset"]');
    this.persistentContainer = document.getElementById('main-persistent-initial');

    this.initPersistentMode();
  }

  setupEventListeners() {
    let allSearchForms = [];
    this.allSearchInputs.forEach((input) => allSearchForms.push(input.form));
    // this.input.addEventListener('focus', this.onInputFocus.bind(this));
    if (allSearchForms.length < 2) return;
    allSearchForms.forEach((form) => form.addEventListener('reset', this.onFormReset.bind(this)));
    this.allSearchInputs.forEach((input) => input.addEventListener('input', this.onInput.bind(this)));
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.keepInSync('', this.input);
    }
  }

  onInput(event) {
    const target = event.target;
    this.keepInSync(target.value, target);
  }

  // onInputFocus() {
  //   const isSmallScreen = window.innerWidth < 750;
  //   if (isSmallScreen) {
  //     this.scrollIntoView({ behavior: 'smooth' });
  //   }
  // }

  keepInSync(value, target) {
    this.allSearchInputs.forEach((input) => {
      if (input !== target) {
        input.value = value;
        const searchForm = input.closest('search-form') || input.closest('main-search') || input.closest('predictive-search');
        if (searchForm && typeof searchForm.toggleResetButton === 'function') {
          searchForm.toggleResetButton();
        }
      }
    });
  }

   initPersistentMode() {
    if (!this.resetBtn || !this.persistentContainer) return;

    // Activate persistent mode ONLY when reset is clicked here
    this.resetBtn.addEventListener('click', () => {
      setTimeout(() => {
        if (!this.input.value.trim()) {
          document.body.classList.add('main-search-persistent-mode');
          this.persistentContainer.classList.remove('hidden');
          document.body.classList.remove("gl-search-open")
          this.renderRecentInPersistent();
        }
      }, 30);
    });

    // When typing → keep background visible, let predictive overlay
    this.input.addEventListener('input', () => {
      // No need to hide anything – persistent mode already handles visibility
    });

    // When actually submitting form → exit persistent mode
    this.input.closest('form').addEventListener('submit', () => {
      document.body.classList.remove('main-search-persistent-mode');
      this.persistentContainer.classList.add('hidden');
    });
  }

  renderRecentInPersistent() {
    const list = this.persistentContainer.querySelector('.recent-searches-list');
    if (!list) return;

    const urlParams = new URLSearchParams(window.location.search);
    const isKidsView = false;
    const storageKey = isKidsView ? 'recent-searches-kids' : 'recent-searches-main';

    const searches = this.getRecentSearches(storageKey);
    const module = list.closest('.recent-searches-module');

    if (searches.length === 0) {
      module.style.display = 'none';
      return;
    }

    module.style.display = 'block';
    list.innerHTML = '';

    searches.forEach(term => {
      const a = document.createElement('a');
      a.href = isKidsView 
        ? `/search?q=${encodeURIComponent(term)}&options[prefix]=last&view=kids&vendor=ABERCROMBIE+KIDS`
        : `/search?q=${encodeURIComponent(term)}&options[prefix]=last&vendor=ABERCROMBIE+%26+FITCH`;
      a.textContent = term;
      list.appendChild(a);
    });
  }

  decodeHtmlEntities(value) {
    const textarea = document.createElement('textarea');
    textarea.innerHTML = value;
    return textarea.value;
  }

  normalizeRecentSearchTerm(term) {
    return this.decodeHtmlEntities(String(term || '')).trim();
  }

  getRecentSearches(storageKey) {
    try {
      return JSON.parse(localStorage.getItem(storageKey) || '[]')
        .map((term) => this.normalizeRecentSearchTerm(term))
        .filter(Boolean);
    } catch (error) {
      localStorage.removeItem(storageKey);
      return [];
    }
  }
}

customElements.define('main-search', MainSearch);

// Global Clear All listener for main-search (syncs with header)
document.addEventListener('click', e => {
  if (e.target.matches('#main-persistent-initial .clear-recent-searches')) {
    const urlParams = new URLSearchParams(window.location.search);
    const isKidsView = false;
    const storageKey = isKidsView ? 'recent-searches-kids' : 'recent-searches-main';
    localStorage.removeItem(storageKey);
    
    if (isKidsView && typeof window.renderRecentSearchesKids === 'function') {
      window.renderRecentSearchesKids();
    } else if (!isKidsView && typeof window.renderRecentSearchesMain === 'function') {
      window.renderRecentSearchesMain();
    }
  }
});

// Save recent search on main-search submit (syncs with header)
document.addEventListener('submit', e => {
  if (e.target.matches('main-search form')) {
     // We no longer save here. Saving is handled on the search results page.
  }
});


  // Preserve vendor parameter in URL for Globo Filter
  (function() {
    const ADULT_VENDOR = 'ABERCROMBIE & FITCH';
    const KIDS_DISABLED = true;

    function preserveVendorParameter() {
      const urlParams = new URLSearchParams(window.location.search);
      const vendor = urlParams.get('vendor');
      const hadKidsView = urlParams.get('view') === 'kids';

      if (KIDS_DISABLED && hadKidsView) {
        urlParams.delete('view');
        urlParams.set('vendor', ADULT_VENDOR);
        const newUrl = window.location.pathname + '?' + urlParams.toString();
        window.history.replaceState({}, '', newUrl);
      }
      
      if (vendor) {
        // Always normalize to adult vendor since kids is hidden
        const normalizedVendor = ADULT_VENDOR;
        sessionStorage.setItem('searchVendor', normalizedVendor);

        // If the URL had a kids vendor, correct it immediately
        if (vendor !== normalizedVendor) {
          urlParams.set('vendor', normalizedVendor);
          urlParams.delete('view'); // Remove kids view if present
          const newUrl = window.location.pathname + '?' + urlParams.toString();
          window.history.replaceState({}, '', newUrl);
        }
        
        // Monitor URL changes and ensure vendor parameter is preserved
        let lastUrl = window.location.href;
        const checkUrl = setInterval(() => {
          if (window.location.href !== lastUrl) {
            lastUrl = window.location.href;
            const currentParams = new URLSearchParams(window.location.search);
            if (!currentParams.get('vendor') && sessionStorage.getItem('searchVendor')) {
              currentParams.set('vendor', sessionStorage.getItem('searchVendor'));
              const newUrl = window.location.pathname + '?' + currentParams.toString();
              window.history.replaceState({}, '', newUrl);
            }
          }
        }, 100);
        
        // Clean up on page unload
        window.addEventListener('beforeunload', () => {
          clearInterval(checkUrl);
        });
      } else if (sessionStorage.getItem('searchVendor')) {
        // Restore vendor if it exists in sessionStorage
        const currentParams = new URLSearchParams(window.location.search);
        currentParams.set('vendor', sessionStorage.getItem('searchVendor'));
        const newUrl = window.location.pathname + '?' + currentParams.toString();
        window.history.replaceState({}, '', newUrl);
      }
    }
    
    // Run on page load
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        preserveVendorParameter();
        injectGloboSwatchColors();
      });
    } else {
      preserveVendorParameter();
      injectGloboSwatchColors();
    }
    
    // Run after Globo Filter renders
    window.addEventListener('globoFilterRenderCompleted', function (event) {
      preserveVendorParameter();
      moveClearAllButton();
      setTimeout(function () {
        cardWishlist();
        swatchImageChange();
        injectGloboSwatchColors();
      }, 2000);
    });
  })();

function moveClearAllButton() {
  // Only run on search page
  const isSearch =
    window.location.pathname.includes("/search") ||
    document.querySelector(".template-search");
  if (!isSearch) return;

  // Try scoped selector first, fall back to any .globo-selected-items on the page
  const container =
    document.querySelector("#gf-grid .globo-selected-items") ||
    document.querySelector(".globo-selected-items");

  if (!container) return;

  // Count real filter pills (exclude any previously injected Clear All wrapper)
  const hasItems =
    container.querySelectorAll(".selected-item:not(.search-clear-btn-wrapper)")
      .length > 0;

  // Remove any previously injected button to avoid duplicates
  const existing = container.querySelector(".search-clear-btn-wrapper");
  if (existing) existing.remove();

  if (hasItems) {
    // Create the Clear All button fresh each time
    const li = document.createElement("li");
    li.className = "selected-item gf-option-label search-clear-btn-wrapper";

    const btn = document.createElement("button");
    btn.className = "link-button clear-link-button mobile-clear-btn";
    btn.setAttribute("onclick", "handleClearAll()");
    btn.setAttribute("data-theme", "default");
    btn.setAttribute("type", "button");
    // btn.style.textDecoration = "underline";
    btn.style.textTransform ="capitalize";
    btn.textContent = "Clear All";

    li.appendChild(btn);
    container.appendChild(li);

    // Ensure the container itself is visible
    container.style.removeProperty("display");
  }
}

function cardWishlist() {
  let wishlist = JSON.parse(localStorage.getItem("myWishlist")) || [];
  // Initialize all wishlist buttons in grid
  document
    .querySelectorAll(".wishlist-collection-icon")
    .forEach((wishlistBtn) => {
      const productId = wishlistBtn.dataset.productId;
      const variantId = wishlistBtn.dataset.variantId;
      // Find matching remove button (sibling or via data attribute)
      const addedBtn = wishlistBtn
        ?.closest(".card-wishlist-share-wrapper")
        ?.querySelector(".remove-list");
      if (!wishlistBtn || !addedBtn) return;

      // ✅ Detect current color code (if swatches exist in this card)
      let colorcode = "";
      const cardContainer =
        wishlistBtn
          .closest(".product-card-wrapper")
          ?.querySelector('[data-option-name="Color"]') ||
        wishlistBtn
          .closest(".product-card-wrapper")
          ?.querySelector('[data-option-name="color"]');
      const selectedColor = cardContainer?.querySelector(
        ".spf-product__swatch.is-selected"
      )?.dataset?.optionValue;
      if (selectedColor) {
        colorcode = selectedColor;
      }

      // Show correct button on load
      if (wishlist.some((item) => item.variantColor === colorcode)) {
        wishlistBtn.classList.add("!hidden");
        addedBtn.classList.remove("!hidden");
      } else {
        wishlistBtn.classList.remove("!hidden");
        addedBtn.classList.add("!hidden");
      }

      // Add to wishlist
      wishlistBtn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        let colorcode = "";
        const cardContainer =
          e.target
            .closest(".product-card-wrapper")
            ?.querySelector('[data-option-name="Color"]') ||
          e.target
            .closest(".product-card-wrapper")
            ?.querySelector('[data-option-name="color"]');
        const selectedColor = cardContainer.querySelector(
          ".spf-product__swatch.is-selected"
        )?.dataset?.optionValue;
        if (selectedColor) {
          colorcode = selectedColor;
        }

        const product = {
          id: productId,
          variantId: variantId,
          title: wishlistBtn.dataset.productTitle,
          handle: wishlistBtn.dataset.productHandle,
          variantColor: colorcode,
          addedAt: Date.now(),
        };

        wishlist.push(product);
        localStorage.setItem("myWishlist", JSON.stringify(wishlist));
        syncWishlist();
        handleWishlistSyncFlow();
        wishlistBtn.classList.add("!hidden");
        addedBtn.classList.remove("!hidden");
        // If flyout already exists, remove it first
        const existingFlyout = document.querySelector(
          '[data-testid="my-list-flyout"]'
        );
        if (existingFlyout) existingFlyout.remove();

        // Create flyout HTML
        let flyoutClasses = "";

        let smallMessageHTML = "";
        if (!window.wishlistLabel?.customerLoggedIn) {
          smallMessageHTML = `
        <div>
         <p class="catalog-MyListNotifications-module__bigMessage" data-property="GLB_GUEST_ITEM_SAVED">
                <span class="catalog-MyListNotifications-module__heart">
                  <span aria-hidden="true" class="icon" data-icon="heart-filled-anf"></span>
                </span>
                ${window.wishlistLabel.addToWishlist}
              </p>
          <div class="catalog-MyListNotifications-module__smallMessage">
            <p>
              <span data-property="GLB_SIGNIN_HEARTS">
                <modal-opener data-modal="#LoginModal">
                  <button class="login-trigger signIn" data-variant="tertiary-light" data-redirect="/account">
                    <span class="underline">${window.wishlistLabel.signIn}</span>
                  </button>
                </modal-opener>${window.wishlistLabel.listSubtext}              
              </span>
            </p>
            <p>
              <span data-property="GLB_CREATEACCOUNTLINK">
                <modal-opener data-modal="#CreateAccountModal">
                  <button class="login-trigger signIn" data-variant="tertiary-light" data-redirect="/account">
                    <span class="underline">${window.wishlistLabel.createAcc}</span>
                  </button>
                </modal-opener>               
              </span>
            </p>
          </div>
          </div>
        `;
          flyoutClasses =
            "catalog-MyListNotifications-module__flyout catalog-MyListNotifications-module__firstTime catalog-MyListNotifications-module__loggedOut";
        } else {
          smallMessageHTML = `
          <div>
            <p class="catalog-MyListNotifications-module__bigMessage">
            <span class="catalog-MyListNotifications-module__heart">
                  
                  <span aria-hidden="true" class="icon" data-icon="heart-filled-anf"></span>

                </span>${window.wishlistLabel.itemSaveLogin}</p>
          </div>
        `;
          flyoutClasses =
            "catalog-MyListNotifications-module__flyout catalog-MyListNotifications-module__firstTime";
        }

        // Create flyout HTML with conditional content
        const flyoutHTML = `
        <div data-testid="my-list-flyout" class="flyout-top-gap">
          <div class="${flyoutClasses}">  
          <div>
              ${smallMessageHTML}
              <p class="catalog-MyListNotifications-module__myListButton block">
                <a class="button" data-full-width="true" data-theme="inverse" data-variant="secondary" href="/pages/my-list">${window.wishlistLabel.viewList}</a>
              </p>
            </div>
          </div>
        </div>
      `;

        function getVisibleHeader() {
          const headers = [
            document.getElementById("header-kids-wrapper"),
            document.getElementById("header-adult-wrapper"),
          ];
          for (const header of headers) {
            if (header && getComputedStyle(header).display !== "none") {
              return header;
            }
          }
          return null;
        }
        // // Insert into header
        // const header = getVisibleHeader();
        // if (header) {
        //   header.insertAdjacentHTML("beforeend", flyoutHTML);
        // }

        // // Auto-hide after 3 seconds
        // setTimeout(() => {
        //   const flyout = document.querySelector(
        //     '[data-testid="my-list-flyout"]'
        //   );
        //   if (flyout) flyout.remove();
        // }, 3000);

        const isAppView = window.location.search.includes("app-view=true");

        if (isAppView) {
          // Bottom fixed layout for app-view mode
          const appViewFlyout = `
            <div class="app-view-wishlist-flyout">
              <p class="flyout-text">The item has been saved</p>
              <a href="/pages/my-list" class="flyout-btn">My List</a>
            </div>
          `;

          //   const appViewFlyout = `
          //   <div class="app-view-wishlist-flyout">
          //     <p class="flyout-text">The item has been saved</p>
          //   </div>
          // `;
          document.body.insertAdjacentHTML("beforeend", appViewFlyout);

          //Auto-hide after 3 seconds
          setTimeout(() => {
            const flyout = document.querySelector(".app-view-wishlist-flyout");
            if (flyout) flyout.remove();
          }, 3000);
        } else {
          // Default header flyout (desktop/normal collection)
         const header = getVisibleHeader();
         if (header) {
        header.insertAdjacentHTML("beforeend", flyoutHTML);
        toggleFlyoutGap();
        }

          setTimeout(() => {
            const flyout = document.querySelector(
              '[data-testid="my-list-flyout"]'
            );
            if (flyout) flyout.remove();
          }, 3000);
        }
      });

      // Remove from wishlist
      addedBtn.addEventListener("click", function () {
        wishlist = wishlist.filter((item) => item.variantColor !== colorcode);
        localStorage.setItem("myWishlist", JSON.stringify(wishlist));
        syncWishlist();
        handleWishlistSyncFlow();
        addedBtn.classList.add("!hidden");
        wishlistBtn.classList.remove("!hidden");
      });
    });
}

  function swatchImageChange() {
  document.querySelectorAll('.spf-card-swatch').forEach((swatch) => {
    // Hover to change image
    swatch.addEventListener('mouseenter', (e) => {
      console.log(e);
      e.preventDefault();
      const mediaSrc = e.currentTarget.dataset.mediaSrc;
      const card = e.currentTarget.closest('.card-wrapper');
      if (!card || !mediaSrc) return;

      const mediaContainer = card.querySelector('.card__media .media');
      if (!mediaContainer) return;

      // Remove any previously injected swatch preview image
      const existing = mediaContainer.querySelector('.swatch-preview');
      if (existing) existing.remove();

      // Create a new image
      const newImg = document.createElement('img');
      newImg.src = mediaSrc;
      newImg.className = 'swatch-preview';
      newImg.setAttribute('style', 'opacity: 1; z-index: 1;');
      newImg.setAttribute('alt', ''); // optional
      newImg.setAttribute('loading', 'lazy');
      // Insert before all children (as the first child)
      mediaContainer.insertBefore(newImg, mediaContainer.firstChild);
    });

    // Optional: reset to first image when mouse leaves swatch area
    swatch.addEventListener('mouseleave', (e) => {
      const card = e.currentTarget.closest('.card-wrapper');
      if (!card) return;
      const mediaContainer = card.querySelector('.card__media .media');
      const existing = mediaContainer?.querySelector('.swatch-preview');
      if (existing) existing.remove();
    });
  });
}
function injectGloboSwatchColors() {
  const swatches = document.querySelectorAll('.spf-product__swatch[data-option-value]');
  swatches.forEach(swatch => {
      if (swatch.dataset.swatchInjected) return;

      const optionValue = swatch.getAttribute('data-option-value');
      const swatchElement = swatch.querySelector('.spf-card-swatch');
      if (!optionValue || !swatchElement) return;

      const cdnUrl = "https://cdn.shopify.com/s/files/1/0696/3848/8143/files/";
      const extensions = [".jpg", ".png", ".jpeg"];
      let baseName = "";

      if (optionValue.toLowerCase().includes("pattern")) {
        baseName = optionValue
          .replace(/&/g, "")
          .replace(/[\s/]+/g, "_")
          .replace(/[^a-zA-Z0-9_-]+/g, "")
          .replace(/_+/g, "_")
          .replace(/^_|_$/g, "");
      } else {
        baseName = optionValue.toLowerCase().replace(/[^a-z0-9]+/g, "-");
      }

      const tryLoad = (index) => {
        if (index >= extensions.length) return;
        const extension = extensions[index];
        const bgUrl = `${cdnUrl}${baseName}${extension}`;

        const img = new Image();
        img.onload = () => {
          swatchElement.style.backgroundImage = `url('${bgUrl}')`;
          swatchElement.style.backgroundSize = "cover";
          swatchElement.style.backgroundRepeat = "no-repeat";
          swatchElement.style.backgroundPosition = "center";
          swatchElement.classList.add("is-injected");
        };
        img.onerror = () => tryLoad(index + 1);
        img.src = bgUrl;
      };

      tryLoad(0);
      swatch.dataset.swatchInjected = "true";
  });
}
document.addEventListener("DOMContentLoaded", function () {
  document.addEventListener("click", function (e) {
    console.log(e, "Sfsddsfsdfsf");
    if (e.target.closest("#cart-icon-bubble")) {
      console.log("Cart icon clicked!");
      const cartDrawer = document.querySelector("cart-drawer");
      console.log(cartDrawer);
      // cartDrawer.style.display = "block !important";
      // cartDrawer.style.visibility = "visible !important";
      cartDrawer.classList.add("active", "animate");
    }
  });
});
